<script setup>
  import { computed } from "vue";
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import Popup from "@/components/controls/Popup.vue";
  import Icon from "@/components/icons/Icon.vue";

  const props = defineProps({
    modelInfo: {
      type: Object,
      required: true
    }
  });

  const isDesktop = useMediaQuery('(min-width: 840px)');

  const popUpPositionY = computed(() => isDesktop.value ? 'top' : 'bottom');


</script>
<template>
  <Popup
    :id="props.modelInfo.id"
    icon="info"
    class="jwx-source-selector__popup-button"
    :teleport="true"
    :positionY="popUpPositionY"
  >
    <template #button-content>
      <div class="jwx-popup__button">
        <Icon name="info" class="jwx-popup__button-icon" data-size="xxlarge" />
        <span class='sr-only'>View Model Info</span>
      </div>
    </template>
    <template #menu-content>
      <div class="jwx-popup-menu">
        <div class="jwx-source-selector__info-popup">
          <p class="jwx-source-selector__info-name">{{ props.modelInfo.modelName }}</p>
          <p class="jwx-source-selector__info-run-name">{{ props.modelInfo.modelRunName }}</p>
          <p class="jwx-source-selector__info-run-date">{{ props.modelInfo.runDate }}</p>
        </div>            
      </div>
    </template>
  </Popup>
</template>